const HIGHLIGHT_TYPES = {
  // SENTIMENT
  'pos-keyword': {
    id: 'pos-keyword',
    label: 'Positive Phrases',
    className: 'positive-sentiment',
    toolOptions: ['search', 'keyword', 'note', 'ban'],
  },
  'neg-keyword': {
    id: 'neg-keyword',
    label: 'Negative Phrases',
    className: 'negative-sentiment',
    toolOptions: ['search', 'keyword', 'note', 'ban'],
  },

  // THEME
  'theme-keyword': {
    id: 'theme-keyword',
    label: 'Theme Keyword',
    className: 'theme',
    toolOptions: ['search', 'note', 'ban'],
  },
  'theme-note': {
    id: 'theme-note',
    label: 'Theme Note',
    className: 'note',
    toolOptions: ['remove-note'],
  },
  // A match the backend found but text match failed (e.g. used to be for lemmas before keyword matches, but can save for later)
  'theme-match': {
    id: 'theme-match',
    label: 'Theme Match',
    className: 'match',
    toolOptions: [],
  },

  // sort by themes (match keywords)
  'match-keyword': {
    id: 'match-keyword',
    label: 'Match Keyword',
    className: 'match',
    toolOptions: ['keyword', 'note', 'ban'],
  },

  // SEARCH
  'search-keyword': {
    id: 'search-keyword',
    label: 'Search Keyword',
    className: 'search',
    toolOptions: ['keyword', 'note', 'ban'],
  },
};

const SELECTABLE_TOOL_OPTIONS = {
  keyword: {
    id: 'keyword',
    label: 'Add Keyword',
  },
  note: {
    id: 'note',
    label: 'Add note',
  },

  similar: {
    id: 'similar',
    label: 'Find similar',
  },
  /* remove buttons */
  'remove-note': {
    id: 'remove-note',
    label: 'Remove note',
  },
  'remove-keyword': {
    id: 'remove-keyword',
    label: 'Drop keyword',
  },
  'ignore-theme': {
    id: 'ignore-theme',
    label: 'Ignore keyword matches',
  },
};
// "search"
const SELECTABLE_TOOL_OPTIONS_KEYWORD = ['ignore-theme'];
const SELECTABLE_TOOL_OPTIONS_NOTE = ['similar', 'remove-note'];
const SELECTABLE_TOOL_OPTIONS_DEFAULT = ['keyword', 'note'];

export {
  HIGHLIGHT_TYPES,
  SELECTABLE_TOOL_OPTIONS,
  SELECTABLE_TOOL_OPTIONS_KEYWORD,
  SELECTABLE_TOOL_OPTIONS_NOTE,
  SELECTABLE_TOOL_OPTIONS_DEFAULT,
};
